import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import ErrorBoundary from "../../../../error-boundary";
import Image from "../../../image/image";
import {useSelector} from "react-redux";

const ImageComponent = ({ content }) => {
  const imageData = content.fieldImageEnhancedRawField.first;
  return (
    <article className="media-image">
      <Image
        data={imageData.entity.fieldMediaImage}
        credit={imageData.entity.fieldCredits}
        caption={
          imageData.defaultCaption === false ? imageData.customCaption : null
        }
      />
    </article>
  );
};

const ParagraphImage = ({ content }) => {
  const sectionClassNames = classNames({
    "paragraph paragraph-image": true,
    [`format-${content.fieldPosition}`]: true,
    [`size-${content.fieldSize}`]: true,
  }),
  microSite = useSelector((reduxStore) => reduxStore.appStore.microSite);

  return (
    <section className={sectionClassNames}>
      {content.fieldSize === "full-bleed" ? (
        <ErrorBoundary>
          <article className="media-image">
            <ImageComponent content={content} />
          </article>
        </ErrorBoundary>
      ) : (
        <div className="container">
          <div className="row">
            <div
              className={classNames({
                "col-12": true,
                "col-lg-9 offset-lg-2": !microSite && content.fieldPosition === "centered",
                "col-lg-9": !microSite && content.fieldPosition === "left",
                "col-lg-9 offset-lg-3": !microSite && content.fieldPosition === "right",
                "col-lg-7 offset-lg-5": microSite
              })}
            >
              <article className="media-image">
                <ImageComponent content={content} />
              </article>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

const paragraphPropTypes = {
  viewMode: PropTypes.string,
  content: PropTypes.shape({
    fieldImageEnhancedRawField: PropTypes.shape({
      first: PropTypes.shape({
        customCaption: PropTypes.string,
        defaultCaption: PropTypes.bool,
        entity: PropTypes.shape({
          fieldCredits: PropTypes.string,
          fieldCaption: PropTypes.string,
          fieldMediaImage: PropTypes.shape({
            alt: PropTypes.string,
            title: PropTypes.string,
            style: PropTypes.shape({
              url: PropTypes.string.isRequired,
            }),
          }),
        }),
      }),
    }),
    fieldPosition: PropTypes.oneOf(["center", "left", "right"]),
    fieldSize: PropTypes.oneOf(["full-bleed", "standard"]),
  }),
};

ImageComponent.propTypes = paragraphPropTypes;
ParagraphImage.propTypes = paragraphPropTypes;

export default ParagraphImage;
